"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireWildcard(require("react"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _runtime = require("@preact/signals-react/runtime");
var _signalsReact = require("@preact/signals-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      margin: "auto"
    },
    paper: {
      width: "100%",
      height: 500,
      overflow: "auto"
    },
    button: {
      margin: theme.spacing(0.5, 0.5)
    },
    rootPaperLeft: {
      paddingLeft: "0px !important"
    },
    rootPaperRight: {
      paddingRight: "8px !important"
    },
    label: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    listItemText: {
      "& span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    },
    gridEmpty: {
      width: "100%",
      marginTop: theme.spacing(1),
      overflow: "hidden"
    },
    draggableItem: {
      cursor: "grab",
      "&:active": {
        cursor: "grabbing"
      }
    },
    draggingOver: {
      backgroundColor: theme.palette.action.hover,
      borderTop: "2px solid ".concat(theme.palette.primary.main)
    },
    dragHandle: {
      display: "flex",
      alignItems: "center",
      marginRight: theme.spacing(1),
      color: theme.palette.text.secondary,
      cursor: "grab",
      userSelect: "none",
      "&:active": {
        cursor: "grabbing"
      }
    },
    dragging: {
      opacity: 0.4
    }
  };
});
var DraggableRightList = function DraggableRightList(_ref) {
  var items = _ref.items,
    getItemIdentifier = _ref.getItemIdentifier,
    getItemText = _ref.getItemText,
    setChecked = _ref.setChecked,
    onReorder = _ref.onReorder,
    emptyText = _ref.emptyText;
  (0, _runtime.useSignals)();
  var classes = useStyles();
  var dragIndexRef = (0, _react.useRef)(null);
  var overIndex = (0, _runtime.useSignal)(null);
  var draggingIndex = (0, _runtime.useSignal)(null);
  var handleDragStart = (0, _react.useCallback)(function (index) {
    dragIndexRef.current = index;
    draggingIndex.value = index;
  }, []);
  var handleDragEnter = (0, _react.useCallback)(function (index) {
    if (dragIndexRef.current !== null && dragIndexRef.current !== index) {
      overIndex.value = index;
    }
  }, []);
  var handleDragOver = (0, _react.useCallback)(function (e) {
    e.preventDefault();
  }, []);
  var handleDrop = (0, _react.useCallback)(function (dropIndex) {
    var fromIndex = dragIndexRef.current;
    if (fromIndex === null || fromIndex === dropIndex) return;
    onReorder(fromIndex, dropIndex);
    dragIndexRef.current = null;
    (0, _signalsReact.batch)(function () {
      overIndex.value = null;
      draggingIndex.value = null;
    });
  }, [onReorder]);
  var handleDragEnd = (0, _react.useCallback)(function () {
    dragIndexRef.current = null;
    (0, _signalsReact.batch)(function () {
      overIndex.value = null;
      draggingIndex.value = null;
    });
  }, []);
  var handleToggle = (0, _react.useCallback)(function (item) {
    item.checked = !item.checked;
    setChecked(function (c) {
      return item.checked ? ++c : --c;
    });
  }, [setChecked]);
  if (items.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
      style: {
        width: "100%",
        height: 500,
        overflow: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      container: true,
      spacing: 1,
      alignItems: "center",
      justifyContent: "center",
      style: {
        width: "100%",
        marginTop: 8,
        overflow: "hidden"
      }
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      component: "legend",
      style: {
        marginBottom: 8,
        marginTop: 8
      }
    }, emptyText)));
  }
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    style: {
      width: "100%",
      height: 500,
      overflow: "auto"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, items.map(function (item, index) {
    item.checked = !!item.checked;
    var labelId = "".concat(getItemIdentifier(item));
    var isDragging = draggingIndex.value === index;
    var isOver = overIndex.value === index;
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: getItemIdentifier(item),
      button: true,
      disableRipple: true,
      disabled: item.disabled,
      draggable: true,
      onDragStart: function onDragStart() {
        return handleDragStart(index);
      },
      onDragEnter: function onDragEnter() {
        return handleDragEnter(index);
      },
      onDragOver: handleDragOver,
      onDrop: function onDrop() {
        return handleDrop(index);
      },
      onDragEnd: handleDragEnd,
      style: {
        height: 35,
        opacity: isDragging ? 0.4 : 1,
        borderTop: isOver ? "2px solid #1976d2" : undefined,
        backgroundColor: isOver ? "rgba(25, 118, 210, 0.04)" : undefined,
        transition: "border-top 0.1s, background-color 0.1s",
        userSelect: "none"
      },
      onClick: function onClick() {
        return handleToggle(item);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      title: "Arrastar para reordenar",
      style: {
        display: "flex",
        alignItems: "center",
        marginRight: 4,
        color: "rgba(0,0,0,0.38)",
        cursor: "grab",
        fontSize: 18,
        lineHeight: 1
      },
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      }
    }, "\u283F"), /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      size: "small",
      checked: item.checked,
      tabIndex: -1,
      disableRipple: true,
      inputProps: {
        "aria-labelledby": labelId
      }
    })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      size: "small",
      id: labelId,
      primary: getItemText(item),
      style: {
        "& span": {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }
    }));
  })));
};
var _default = DraggableRightList;
exports["default"] = _default;